import { render, staticRenderFns } from "./AddUserComment.vue?vue&type=template&id=89be0680&scoped=true&"
import script from "./AddUserComment.vue?vue&type=script&lang=js&"
export * from "./AddUserComment.vue?vue&type=script&lang=js&"
import style0 from "./AddUserComment.vue?vue&type=style&index=0&id=89be0680&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89be0680",
  null
  
)

export default component.exports